import type { Language } from '@nordcrest/shared';
import sv from './sv.json';
import en from './en.json';

const translations = { sv, en };

type TranslationKeys = typeof sv;

function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const keys = path.split('.');
  let current: unknown = obj;

  for (const key of keys) {
    if (current === null || current === undefined || typeof current !== 'object') {
      return path;
    }
    current = (current as Record<string, unknown>)[key];
  }

  return typeof current === 'string' ? current : path;
}

export function t(
  key: string,
  language: Language,
  params?: Record<string, string | number>
): string {
  const translation = getNestedValue(translations[language] as unknown as Record<string, unknown>, key);

  if (params) {
    return Object.entries(params).reduce(
      (str, [key, value]) => str.replace(new RegExp(`{{${key}}}`, 'g'), String(value)),
      translation
    );
  }

  return translation;
}

export { sv, en };
export type { TranslationKeys };
